import React from "react";
import styled from "styled-components";
import { Table } from "antd";
import TripLabelChip from "./TripLabelChip.jsx";

const OrderGroup = styled.div`
  margin-bottom: 24px;
`;

const GroupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #f0f5f4;
  border-radius: 8px;
  margin-bottom: 12px;
  border-left: 4px solid #005249;
`;

const GroupTitle = styled.div`
  font-weight: 700;
  font-size: 15px;
  color: #005249;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const GroupCount = styled.div`
  font-size: 12px;
  color: #666;
`;

const TripSubHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  margin: 0 0 8px 8px;
  background: #fafafa;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
`;

const TripSubMeta = styled.span`
  font-size: 12px;
  color: #8c8c8c;
  white-space: nowrap;
`;

/**
 * Renders corridor → trip nested groups for desktop/tablet/mobile list layouts.
 */
export default function GroupedOrdersSections({
  corridorGroups,
  variant = "desktop",
  desktopColumns,
  loading,
  selectedOrderId,
  onSelectOrder,
  renderMobileOrder,
  renderTabletOrder,
  tableScroll,
}) {
  if (!corridorGroups?.length) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "48px 16px",
          color: "#9ca3af",
        }}
      >
        No deliveries in this view
      </div>
    );
  }

  return (
    <>
      {corridorGroups.map((corridor) => (
        <OrderGroup key={corridor.key}>
          <GroupHeader>
            <GroupTitle>{corridor.label}</GroupTitle>
            <GroupCount>
              {corridor.totalCount} order{corridor.totalCount === 1 ? "" : "s"}
            </GroupCount>
          </GroupHeader>

          {corridor.tripGroups.map((tripGroup) => (
            <div key={tripGroup.tripKey} style={{ marginBottom: 16 }}>
              <TripSubHeader>
                <TripLabelChip
                  tripId={tripGroup.tripId}
                  trip={tripGroup.trip}
                  orderCount={tripGroup.orders.length}
                />
                <TripSubMeta>
                  {tripGroup.orders.length} order
                  {tripGroup.orders.length === 1 ? "" : "s"}
                </TripSubMeta>
              </TripSubHeader>

              {variant === "desktop" ? (
                <Table
                  columns={desktopColumns}
                  dataSource={tripGroup.orders}
                  loading={loading}
                  rowKey="id"
                  pagination={false}
                  size="small"
                  scroll={tableScroll}
                  onRow={(record) => ({
                    onClick: () => onSelectOrder?.(record),
                    className:
                      selectedOrderId === record.id ? "ant-table-row-selected" : "",
                    style: {
                      cursor: "pointer",
                      backgroundColor:
                        selectedOrderId === record.id ? "#e6f7ff" : "transparent",
                    },
                  })}
                />
              ) : variant === "tablet" ? (
                <div>
                  {tripGroup.orders.map((order) => renderTabletOrder(order))}
                </div>
              ) : (
                <div>
                  {tripGroup.orders.map((order) => renderMobileOrder(order))}
                </div>
              )}
            </div>
          ))}
        </OrderGroup>
      ))}
    </>
  );
}

export { OrderGroup, GroupHeader, GroupTitle, GroupCount, TripSubHeader };
